module.exports = __webpack_public_path__ + "static/img/58.52c19419.png";